import { render, staticRenderFns } from "./ProdBaseRadio.vue?vue&type=template&id=f75ff7fc&"
import script from "./ProdBaseRadio.vue?vue&type=script&lang=js&"
export * from "./ProdBaseRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports